const BASE = 'https://media.formula1.com/image/upload/content/dam/fom-website/2018-redesign-assets/Circuit%20maps%2016x9';
const T = '.transform/4col/image.png';

export const QUIZ_CIRCUITS = [
  { id: 'bahrain',     gpName: 'Grand Prix de Bahreïn',          img: `${BASE}/Bahrain_Circuit.png${T}` },
  { id: 'saudi',       gpName: 'Grand Prix d\'Arabie Saoudite',   img: `${BASE}/Saudi_Arabia_Circuit.png${T}` },
  { id: 'australia',   gpName: 'Grand Prix d\'Australie',         img: `${BASE}/Australia_Circuit.png${T}` },
  { id: 'japan',       gpName: 'Grand Prix du Japon',             img: `${BASE}/Japan_Circuit.png${T}` },
  { id: 'china',       gpName: 'Grand Prix de Chine',             img: `${BASE}/China_Circuit.png${T}` },
  { id: 'miami',       gpName: 'Grand Prix de Miami',             img: `${BASE}/Miami_Circuit.png${T}` },
  { id: 'imola',       gpName: 'Grand Prix d\'Émilie-Romagne',    img: `${BASE}/Emilia_Romagna_Circuit.png${T}` },
  { id: 'monaco',      gpName: 'Grand Prix de Monaco',            img: `${BASE}/Monaco_Circuit.png${T}` },
  { id: 'canada',      gpName: 'Grand Prix du Canada',            img: `${BASE}/Canada_Circuit.png${T}` },
  { id: 'spain',       gpName: 'Grand Prix d\'Espagne',           img: `${BASE}/Spain_Circuit.png${T}` },
  { id: 'austria',     gpName: 'Grand Prix d\'Autriche',          img: `${BASE}/Austria_Circuit.png${T}` },
  { id: 'gb',          gpName: 'Grand Prix de Grande-Bretagne',   img: `${BASE}/Great_Britain_Circuit.png${T}` },
  { id: 'hungary',     gpName: 'Grand Prix de Hongrie',           img: `${BASE}/Hungary_Circuit.png${T}` },
  { id: 'belgium',     gpName: 'Grand Prix de Belgique',          img: `${BASE}/Belgium_Circuit.png${T}` },
  { id: 'netherlands', gpName: 'Grand Prix des Pays-Bas',         img: `${BASE}/Netherlands_Circuit.png${T}` },
  { id: 'italy',       gpName: 'Grand Prix d\'Italie',            img: `${BASE}/Italy_Circuit.png${T}` },
  { id: 'singapore',   gpName: 'Grand Prix de Singapour',         img: `${BASE}/Singapore_Circuit.png${T}` },
  { id: 'baku',        gpName: 'Grand Prix d\'Azerbaïdjan',       img: `${BASE}/Baku_Circuit.png${T}` },
  { id: 'usa',         gpName: 'Grand Prix des États-Unis',       img: `${BASE}/USA_Circuit.png${T}` },
  { id: 'mexico',      gpName: 'Grand Prix du Mexique',           img: `${BASE}/Mexico_Circuit.png${T}` },
  { id: 'brazil',      gpName: 'Grand Prix de São Paulo',         img: `${BASE}/Brazil_Circuit.png${T}` },
  { id: 'lasvegas',    gpName: 'Grand Prix de Las Vegas',         img: `${BASE}/Las_Vegas_Circuit.png${T}` },
  { id: 'qatar',       gpName: 'Grand Prix du Qatar',             img: `${BASE}/Qatar_Circuit.png${T}` },
  { id: 'abudhabi',    gpName: 'Grand Prix d\'Abu Dhabi',         img: `${BASE}/Abu_Dhabi_Circuit.png${T}` },
];

export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function getOptions(correct, all) {
  const wrong = shuffle(all.filter(c => c.id !== correct.id)).slice(0, 2);
  return shuffle([correct, ...wrong]);
}
